import SpecForm from "./SpecForm";

export default SpecForm;
